import axios from "axios";
import {API} from "@/services/url";

export default {
  login: function (credentials, success, error) {
    axios.post(API.auth.signIn, credentials).then(
      r => {
        return success(r.data.accessToken);
      }).catch(e => error(e));
  }
}
